// Dummy Vehicle Data for the demo EV

const dummyVehicleData = {
  vin: 'MHIDEMO0000000001',
  model: 'Light commercial EV',
  year: 2024,
  color: 'Glacier White',

  odometer: 8547, // km

  location: {
    lat: 18.5204,
    lon: 73.8567,
    city: 'Pune',
    state: 'Maharashtra',
    country: 'India'
  },

  status: 'parked', // parked, driving, charging
  speed: 0, // km/h
  gear: 'P', // P, D, R, N

  doors: {
    frontLeft: 'closed',
    frontRight: 'closed',
    rearLeft: 'closed',
    rearRight: 'closed',
    trunk: 'closed',
    hood: 'closed'
  },

  climate: {
    interior: 32, // °C
    exterior: 28, // °C
    hvacStatus: 'off', // off, cooling, heating
    targetTemp: 22, // °C
    fanSpeed: 0 // 0-5
  },

  tyres: [
    { position: 'FL', pressure: 2.3, temperature: 28, status: 'normal' },
    { position: 'FR', pressure: 2.3, temperature: 28, status: 'normal' },
    { position: 'RL', pressure: 2.2, temperature: 27, status: 'normal' },
    { position: 'RR', pressure: 2.2, temperature: 27, status: 'normal' }
  ],

  lights: {
    headlights: 'off',
    taillights: 'off',
    indicators: 'off',
    interior: 'off'
  },

  charging: {
    isCharging: false,
    chargerConnected: false,
    chargeRate: 0, // kW
    timeToFull: 0, // minutes
    chargingType: null // AC, DC, null
  },

  tripData: {
    currentTrip: {
      distance: 0, // km
      duration: 0, // minutes
      avgSpeed: 0, // km/h
      energyUsed: 0 // kWh
    },
    lastTrip: {
      distance: 23, // km
      duration: 42, // minutes
      avgSpeed: 35, // km/h
      energyUsed: 3.8, // kWh
      regenEnergy: 0.3 // kWh recovered
    },
    lifetime: {
      totalDistance: 8547, // km
      totalEnergyUsed: 1456, // kWh
      avgEfficiency: 170 // Wh/km
    }
  },

  system: {
    firmwareVersion: '2.4.1',
    lastUpdate: Date.now() - 15 * 24 * 60 * 60 * 1000, // 15 days ago
    connectivity: 'connected', // connected, disconnected
    gpsSignal: 'strong', // strong, weak, none
    cellularSignal: 'strong'
  },

  owner: {
    name: 'Demo User',
    phone: '+91-XXXXXXXXXX',
    email: 'demo@example.com',
    registrationDate: '2023-08-15'
  }
};

export default dummyVehicleData;
